<div class="plans-container">
  <div class="header">
    <h2>Plans Management</h2>
    <p-button icon="pi pi-plus" label="Add Plan" severity="primary" (click)="onAddPlanClick()"
      [disabled]="isLoading"></p-button>
  </div>
  @if (isLoading) {
  <div class="loading-container"><p-progressSpinner styleClass="loading-spinner"></p-progressSpinner>
    <p>Loading plans...</p>
  </div>
  } @else {
  <div class="filter-container">
    <div class="search-input-wrapper"><i class="pi pi-search search-icon"></i><input pInputText type="text"
        [(ngModel)]="searchQuery" placeholder="Search by code or name..." class="search-input" /></div>
  </div>
  <div class="table-container"><p-table [value]="filteredPlans" styleClass="plans-table"><ng-template
        pTemplate="header">
        <tr>
          <th>Code</th>
          <th class="hide-mobile">Name</th>
          <th style="width: 6rem; text-align: center;">Actions</th>
        </tr>
      </ng-template><ng-template pTemplate="body" let-plan>
        <tr>
          <td>{{ plan.code || '-' }}</td>
          <td class="hide-mobile">{{ plan.name || '-' }}</td>
          <td style="text-align: center;"><p-button icon="pi pi-pencil" severity="secondary" [text]="true"
              [rounded]="true" (click)="onEditClick(plan)"></p-button></td>
        </tr>
      </ng-template><ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" style="text-align: center;">No plans found.</td>
        </tr>
      </ng-template></p-table></div>
  }
</div>
<p-drawer [(visible)]="showDrawer" position="right" styleClass="plan-drawer" [modal]="true"><ng-template
    pTemplate="header">
    <div class="drawer-header">
      <h3>Edit Plan</h3>
      <a [href]="getLagoBillingUrl()" target="_blank" rel="noopener noreferrer" class="header-external-link">
        <i class="pi pi-external-link"></i> Edit in Lago Billing
      </a>
    </div>
  </ng-template>
  <div class="drawer-content">
    <div class="field readonly-section">
      <h4>Plan Information</h4>
      <div class="readonly-field"><label>Code</label>
        <p>{{ editingPlan.code || '-' }}</p>
      </div>
      <div class="readonly-field"><label>Name</label>
        <p>{{ editingPlan.name || '-' }}</p>
      </div>
      <div class="readonly-field"><label>Description</label>
        <p>{{ editingPlan.description || '-' }}</p>
      </div>
      <div class="readonly-field"><label>Lago ID</label>
        <p>{{ editingPlan.lago_id || '-' }}</p>
      </div>
      <div class="readonly-field"><label>Amount</label>
        <p>{{ formatAmount(editingPlan.amount_cents, editingPlan.amount_currency) }}</p>
      </div>
      <div class="readonly-field"><label>Interval</label>
        <p>{{ editingPlan.interval || '-' }}</p>
      </div>
      <div class="readonly-field"><label>Trial Period</label>
        <p>{{ editingPlan.trial_period || 0 }} days</p>
      </div>
      <div class="readonly-field"><label>Pay in Advance</label>
        <p>{{ editingPlan.pay_in_advance ? 'Yes' : 'No' }}</p>
      </div>
    </div><p-divider />
    <div class="field editable-section">
      <h4>Billing Settings</h4>
      <div class="field">
        <label for="visible">Visible</label>
        <p-toggleSwitch inputId="visible" [(ngModel)]="editingPlan.visible"></p-toggleSwitch>
        <p class="field-description">Plan is visible to all users</p>
      </div>
      <div class="field">
        <label for="visibleToSpecifiedUsers">Visible To Specified Users</label>
        <p-toggleSwitch inputId="visibleToSpecifiedUsers" [(ngModel)]="editingPlan.visible_to_specified_users"></p-toggleSwitch>
        <p class="field-description">Restrict plan visibility to specific users only</p>
      </div>
      <div class="field"><label for="userIds">Users</label><p-multiSelect
          inputId="userIds"
          [(ngModel)]="editingPlan.user_ids"
          [options]="userOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select users"
          [filter]="true"
          filterPlaceholder="Search users"
          [disabled]="!editingPlan.visible_to_specified_users"
          [showToggleAll]="true"
          display="chip"
          styleClass="user-select"
        /></div>
      <div class="field">
        <label for="progressiveBilling">Progressive Billing Enabled</label>
        <p-toggleSwitch
          inputId="progressiveBilling" [(ngModel)]="editingPlan.progressive_billing_enabled"
          [disabled]="!canEnableProgressiveBilling()"></p-toggleSwitch>
        <p class="field-description">Enable progressive billing rules for invoice generation</p>
      </div>@if
      (editingPlan.progressive_billing_enabled && editingPlan.progressive_billing_thresholds) {<div class="field">
        <label>Progressive Billing Thresholds</label>
        <div class="thresholds-list">@for (threshold of editingPlan.progressive_billing_thresholds; track $index) {<div
            class="threshold-item"><p-inputNumber [(ngModel)]="editingPlan.progressive_billing_thresholds![$index]"
              mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
              styleClass="threshold-input"></p-inputNumber><p-button icon="pi pi-trash" severity="danger" [text]="true"
              [rounded]="true" (click)="removeThreshold($index)"></p-button></div>}<p-button icon="pi pi-plus"
            label="Add Threshold" severity="secondary" [text]="true" (click)="addThreshold()"></p-button></div>
      </div>
      <div class="field">
        <label for="stepAmount">Progressive Billing Step Amount</label>
        <p-inputNumber
          inputId="stepAmount"
          [(ngModel)]="editingPlan.progressive_billing_step_amount"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [showButtons]="true"
          [min]="0"
          placeholder="Optional"
        />
        <p class="field-description">Usage increment that triggers invoice generation each time user's outstanding balance exceeds this amount</p>
      </div>}
      <div class="field">
        <label for="terminationAmount">Termination Amount</label>
        <p-inputNumber
          inputId="terminationAmount"
          [(ngModel)]="editingPlan.termination_amount"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [showButtons]="true"
          [min]="0"
          placeholder="Optional"
        />
        <p class="field-description">Outstanding balance threshold at which the subscription will be automatically terminated</p>
      </div>
      <p-divider />
      <h4>Pricing Coefficients</h4>
      <div class="field">
        <label for="sttCoeff">STT Coefficient</label>
        <p-inputNumber
          inputId="sttCoeff"
          [(ngModel)]="editingPlan.stt_coeff"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="10"
          [showButtons]="true"
          [min]="0"
          [step]="0.1"
          placeholder="Optional"
        />
        <p class="field-description">Multiplier coefficient applied to STT pricing for this plan</p>
      </div>
      <div class="field">
        <label for="llmInputTokenCoeff">LLM Input Token Coefficient</label>
        <p-inputNumber
          inputId="llmInputTokenCoeff"
          [(ngModel)]="editingPlan.llm_input_token_price_coeff"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="10"
          [showButtons]="true"
          [min]="0"
          [step]="0.1"
          placeholder="Optional"
        />
        <p class="field-description">Multiplier coefficient applied to LLM input token pricing for this plan</p>
      </div>
      <div class="field">
        <label for="llmOutputTokenCoeff">LLM Output Token Coefficient</label>
        <p-inputNumber
          inputId="llmOutputTokenCoeff"
          [(ngModel)]="editingPlan.llm_output_token_price_coeff"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="10"
          [showButtons]="true"
          [min]="0"
          [step]="0.1"
          placeholder="Optional"
        />
        <p class="field-description">Multiplier coefficient applied to LLM output token pricing for this plan</p>
      </div>
      <div class="field">
        <label for="ttsCoeff">TTS Coefficient</label>
        <p-inputNumber
          inputId="ttsCoeff"
          [(ngModel)]="editingPlan.tts_coeff"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="10"
          [showButtons]="true"
          [min]="0"
          [step]="0.1"
          placeholder="Optional"
        />
        <p class="field-description">Multiplier coefficient applied to TTS pricing for this plan</p>
      </div>
      <p-divider />
      <div class="field">
        <label for="graduatedPricing">Graduated Pricing Billing Enabled</label>
        <p-toggleSwitch
          inputId="graduatedPricing" [(ngModel)]="editingPlan.graduated_pricing_billing_enabled"
          [disabled]="!canEnableGraduatedPricingBilling()"></p-toggleSwitch>
        <p class="field-description">Generate invoices when each pricing tier threshold is reached (applies when per-unit cost is greater than zero)</p>
      </div>@if (hasGraduatedRanges()) {<div
        class="field readonly-field"><label>Pricing Ranges</label>@for (charge of editingPlan.charges; track
        charge.lago_id) {
        <div class="pricing-info">
          <strong>{{ charge.billable_metric_code }}</strong>
          @if (charge.charge_model === 'Dynamic') {
            <p class="dynamic-pricing-notice">Price is determined by usage based on selected model parameters</p>
          } @else if (charge.properties?.graduated_ranges?.length) {
            @for (range of charge.properties!.graduated_ranges!; track $index) {
              <div class="range-display"><span>{{ range.from_value }} @if
                (range.to_value !== null) {- {{ range.to_value }}} @else {+}</span><span>@if (range.flat_amount &&
                range.flat_amount !== '0') {${{ range.flat_amount }} flat}@if (range.per_unit_amount &&
                range.per_unit_amount !== '0') {@if (range.flat_amount && range.flat_amount !== '0') {, }${{
                range.per_unit_amount }}/unit}</span></div>
            }
          }
        </div>
      }</div>}
    </div>
  </div><ng-template pTemplate="footer">
    <div class="drawer-footer"><p-button label="Cancel" severity="secondary" [text]="true" (click)="onCancel()"
        [disabled]="isSaving"></p-button><p-button label="Save" icon="pi pi-save" severity="primary" (click)="onSave()"
        [disabled]="isSaving" [loading]="isSaving"></p-button></div>
  </ng-template>
</p-drawer>